import React from 'react'
import ReactDOM from 'react-dom'
import '@fontsource/roboto'
import '@fontsource/montserrat'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './pdfWorkerSetup'
import QueryClientProviderWrapper from './api/queryClientProviderWrapper'
import { BrowserRouter } from 'react-router-dom'
import Auth0ProviderWithHistory from './authentication/auth0ProviderWithHistory'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithHistory>
        <QueryClientProviderWrapper>
          <App />
        </QueryClientProviderWrapper>
      </Auth0ProviderWithHistory>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
